/**
 * If you have multiple filter fields that are equal to the entity field
 * and just want to filter by the value you can use this function to quickly build it.
 *
 * Example:
 * buildSimpleFilter({ valueOne: 123, valueTwo: false, otherStuff: ... }, 'valueOne', 'valueTwo')
 * => { valueOne: 123, valueTwo: { $ne: true } }
 *
 * @param filter The filter values
 * @param keys The keys for which simple filters should be build
 * @returns The mongo filter
 */
export function buildSimpleFilter(filter: any, ...keys: string[]): any {
  let res = {};
  keys.forEach(key => {
    // We only skip if null or undefined, so that a boolean value of false will
    // be filtered correctly instead of omitted.
    const val = filter[key];
    if (val === null || val === undefined) {
      return;
    }

    res = {
      ...res,
      [key]: val === false ? { $ne: true } : val,
    };
  });
  return res;
}

/**
 * If you have multiple filter fields that you just want to filter by the value you can use this function to quickly build it.
 *
 * Example:
 * buildSimpleFilter({ valueOne: 123, valueTwo: false, otherStuff: ... }, {'valueOne': 'someField.valueOne', 'valueTwo'})
 * => { 'someField.valueOne': 123, valueTwo: { $ne: true } }
 *
 * @param filter The filter values
 * @param mapping The keys from filter to key in mongo mapping
 * @returns The mongo filter
 */
export function buildSimpleFilterMapped(filter: any, mapping: Record<string, string>): any {
  let res = {};
  Object.keys(mapping).forEach(key => {
    // We only skip if null or undefined, so that a boolean value of false will
    // be filtered correctly instead of omitted.
    const val = filter[key];
    if (val === null || val === undefined) {
      return;
    }

    const mongoKey = mapping[key];
    if (!mongoKey) {
      return;
    }
    res = {
      ...res,
      [mongoKey]: val === false ? { $ne: true } : val,
    };
  });
  return res;
}
